import * as index from '@syncfusion/ej2-pdfviewer';
index.PdfViewer.Inject( index.LinkAnnotation,index.BookmarkView,index.Magnification,index.ThumbnailView,index.Toolbar,index.Navigation,index.Print,index.TextSelection,index.TextSearch,index.Annotation);
export * from '@syncfusion/ej2-pdfviewer';
